import Vue from 'vue';
import VueRouter from 'vue-router';

import _ from 'lodash'
import route from './route'
import store from '@/data/store'
import {sspApiNoAdvice} from '@/api';
import webUtils from '@/tools/web-utils'

Vue.use(VueRouter);
const router = new VueRouter(route);

export default router;

let interceptor = async function (to, from, next) {
    if (to.meta.requiresAuth === false) {
        return next()
    }
    let success = true
    await sspApiNoAdvice.getAccount().then((response) => {
        store.commit('setAccountInfo', response);
    }).catch((e) => {
        if (isUnAuthorized(e)) {
            webUtils.redirect2QxLogin();
            success = false
        }
    });
    if (success) next()
}

router.beforeEach(interceptor);

function isUnAuthorized(error) {
    let status = _.at(error, 'response.status')[0];
    return status === 401;
}
